import { Link as NavLink } from "react-router-dom";
import styled from "styled-components";
import tw from "twin.macro";
import { Theme } from "../context";

export const Link = styled(NavLink)`
  ${tw`font-[600] hover:text-buttondefault transition-all ease-in-out duration-500`}
`;

export const JiffyFooter = styled.div<{ rooTheme?: Theme }>`
  ${tw`flex flex-col justify-center pt-16 pb-16 lg:pt-32 md:pb-12 font-clash lg:flex-row`};
  > div:nth-child(1) {
    flex-basis: 20%;
  }

  > div:nth-child(2) {
    flex-basis: 55%;
  }

  > div:nth-child(3) {
    flex-basis: 25%;
  }

  ${({ rooTheme }) => (rooTheme === "dark" ? tw`text-white` : tw`text-black`)}
`;

export const JiffyFooterLinksContainer = styled.div`
  ${tw`flex items-start justify-center gap-7 md:gap-10 lg:pt-8`}

  > div:last-child {
    > ul > li {
      ${tw` font-[600] hover:text-buttondefault transition-all ease-in-out duration-500`}
    }
  }

  @media screen and (max-width: 768px) {
    ${tw`flex-col`}
  }
`;

export const JiffyFooterMenu = styled.ul<{ rooTheme?: Theme }>`
  ${tw`list-none`}
  > li, p {
    ${tw`font-[500]`}
    color: ${({ rooTheme }) =>
      rooTheme === "dark"
        ? "rgba(255, 255, 255, 0.6)"
        : "rgba(30, 30, 30, 0.6)"};
  }
`;

export const JiffyFooterLinks = styled.li`
  ${tw`pb-4 font-[600]  lg:text-[12px] xl:text-base`}
`;

export const JiffyFooterHeading = styled.h2`
  ${tw`font-[600] text-[18px] lg:text-[16px] xl:text-[18px]  pb-4 md:pb-6`}
`;

export const JiffyFooterNewsletter = styled.div``;

export const JiffyFooterNewsLetterHeading = styled.h3`
  ${tw` text-[18px] lg:text-[16px] xl:text-[18px] font-[600] pt-8 md:pt-8`}
`;

export const JiffyFooterNewsLetterParagrah = styled.p<{ rooTheme?: Theme }>`
  ${tw` font-[400] w-[71%] lg:w-[90%] xl:w-[60%] text-[15px] lg:text-[13px] xl:text-[15px] tracking-wide py-3`}
  color: ${({ rooTheme }) => (rooTheme === "dark" ? "white" : "black")};
}
`;

export const JiffyFooterLogo = styled.img`
  ${tw`w-[140px] md:w-[150px]`}
`;

export const JiffyMission = styled.p`
  ${tw`font-[500] w-[75%] md:w-full text-base lg:text-[13px] xl:text-base `}
  @media screen and (max-width:768px) {
    ${tw`pt-5 pb-14`}
  }
`;

export const JiffyLogoContent = styled.div``;

export const JiffyCopyRight = styled.div<{ rooTheme?: Theme }>`
  ${tw`pt-8 pb-10 text-center font-clash font-[400]`}

  border-top: ${({ rooTheme }) =>
    rooTheme === "dark"
      ? "1px rgba(255, 255, 255, 0.1) solid"
      : "1px rgba(30, 30, 30, 0.1) solid"};
`;

export const JiffyCopyRightContent = styled.p<{ rooTheme?: Theme }>`
  ${tw`flex items-center justify-center gap-3`}
  color: ${({ rooTheme }) =>
    rooTheme === "dark" ? "rgba(255, 255, 255, 0.6)" : "rgba(30, 30, 30, 0.6)"};
  font-weight: ${({ rooTheme }) => (rooTheme === "dark" ? "400" : "600")};

  font-size: ${({ rooTheme }) => (rooTheme === "dark" ? "" : "17px")};
`;

export const CopySpan = styled.span`
  ${tw`text-4xl font-[400]`}
`;

export const JiffyEmailUs = styled.div<{ rooTheme?: Theme }>`
  ${tw`hover:text-buttondefault transition-all ease-in-out duration-500 md:text-[13px] xl:text-[16px] w-full lg:w-[90%] xl:w-full`}
  color: ${({ rooTheme }) =>
    rooTheme === "dark" ? "#007fff" : tw`text-black`};
  font-weight: ${({ rooTheme }) => (rooTheme === "dark" ? "500" : "500")};
`;
